<template>
	<div style="overflow-x: hidden !important; overflow-y: hidden">
		<div class="main">
			<div style="padding: 10px; margin-top: 15px">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("browse-folders") }}</h1>
						<h5>{{ computedFolNumber }}</h5>
					</div>
					<div class="header_actions">
						<div class="header_actions-container">
							<search
								:loadDocs="false"
								:loadFolders="true"
								:folderID="undefined"
								from="browse-folders"
								@docSelected="item => {}"
								@folderSelected="
									item => {
										goto('/browse/folders/' + item.id)
									}
								"
								@keyup="
									str => {
										handleSearch(str)
									}
								"
							/>
						</div>
					</div>
				</div>

				<div class="documents infinite-list-wrapper" style="overflow: auto">
					<div
						class="documents_container list"
						v-infinite-scroll="scrollLoad"
						:infinite-scroll-disabled="scrollDisabled"
						infinite-scroll-distance="50"
						style="margin-bottom: 100px"
					>
						<div v-if="expired">
							<div
								style="
									display: flex;
									width: 100%;
									justify-content: space-around;
									align-items: center;
									height: 100%;
								"
							>
								<div>
									<md-icon class="md-size-2x" style="color: #f56c6c">warning</md-icon>
								</div>
								<div style="font-size: 1.2em; margin-left: 10px; font-weight: 500">
									{{ $t("expired-subscription-content") }}
								</div>
							</div>
						</div>
						<div
							v-for="d in folders"
							:key="d.id"
							class="documents_wrapper list-item"
							@click="goto('/browse/folders/' + d.id)"
							v-else
						>
							<div class="documents_upper">
								<div class="documents_thumb">
									<div style="display: flex; height: 100%; overflow-x: hidden">
										<md-icon class="md-size-5x" style="color: #fbbc04">folder</md-icon>
										<div
											style="
												position: absolute;
												top: 52%;
												left: 96%;
												transform: translate(-50%, -50%);
												font-size: 2rem;
												color: #fff;
											"
										>
											{{ d.count }}
										</div>
									</div>
								</div>
							</div>
							<div class="documents_details">
								<div class="documents_details-infos">
									<div class="documents_details-title">{{ d.name }}</div>
									<div class="documents_details-subtitle">{{ d.description.String }}</div>
									<div>
										<el-tag
											v-for="area in d.areas"
											:key="area.id"
											style="margin-left: 3px; margin-bottom: 3px"
											type="success"
										>
											{{ area.area.name }}
										</el-tag>
										<el-tag
											v-for="tag in d.tags"
											:key="tag.id"
											style="margin-left: 3px; margin-bottom: 3px"
										>
											{{ tag.tag.name }}
										</el-tag>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="float-center">
					<div class="float-content-spinner" v-if="scrollLoading">
						<i class="el-icon-loading" />
					</div>
					<div
						class="float-content"
						v-bind:class="{ visible: scrollNoMoreSnackbar, hidden: !scrollNoMoreSnackbar }"
					>
						<div class="float-text">{{ $t("no-more-folders") }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { goto } from "@/utils/utils"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/browse/components/sidebar-components/browse-sidebar.vue"
import Search from "@/modules/browse/components/search"

export default {
	name: "browse-folders",
	components: {
		ButtonCollapseSidebar,
		FoldersSidebar,
		Search
	},
	data() {
		return {
			folders: [],
			foldersNumber: 0,
			showModalRender: false,
			widthScreen: window.innerWidth - 150,
			sidebar: true || window.innerWidth < 900,
			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 1,
			loadedPages: 0,
			expired: false,
			docsSearch: ""
		}
	},
	computed: {
		computedFolNumber: function () {
			return this.$t("folders-counter").replace("%DOCSNUMBER%", this.foldersNumber)
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		}
	},
	created() {
		this.tilesNumber = Math.floor((this.widthScreen - 90) / 340)
		this.getFolders()
	},
	watch: {
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	methods: {
		goto,
		scrollLoad() {
			this.loadedPages++
			this.getFolders()
		},
		getFolders() {
			if (!this.scrollEnded) {
				this.scrollLoading = true
				const url = `${process.env.VUE_APP_API_URL}/api/folders/getBySubscription`
				const payload = {
					pagination: {
						offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
						size: this.rowsToLoad * this.tilesNumber
					},
					search: this.docsSearch.toLowerCase()
				}
				axios
					.post(url, payload, { headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } })
					.then(res => {
						if (res.data.items === 0) this.expired = true
						this.foldersNumber = res.data.total
						if (res.data.items) {
							res.data.items.forEach(f => {
								// const c = res.data.count.find(x => x.Id === f.folder.id)
								this.folders.push({
									id: f.folder.id,
									name: f.folder.name,
									description: f.folder.description,
									count: f.Count,
									tags: f.folder.tags,
									areas: f.folder.areas
								})
							})
						}
						this.scrollLoading = false

						if (!res.data.items || res.data.items.length == 0) {
							this.scrollNoMoreSnackbar = true
							this.scrollEnded = true
						}
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},
		handleSearch(searchstr) {
			this.docsSearch = searchstr
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.folders = []
			this.getFolders(searchstr)
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/documents.scss";
@import "src/assets/scss/collapse-button";

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.main {
	height: calc(100vh - 100px);
	display: flex;
	flex-direction: column;
	margin-top: -25px;
}

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
